<template>
  <ax-panel noTitle>
    <div class="risk-level-wrapper">
      <template v-for="(item, index) in list">
        <div
          :class="['risk-item', 'item' + item.labelLevel]"
          :style="{ color: item.labelColor , backgroundColor: hexToRgba(item.labelColor, 0.1)}"
          v-if="index == 0 && item.labelName"
          :key="index"
        >
          <div class="risk-level">{{ item.labelName }}</div>
          <p class="comment">{{ item.comment }}</p>
        </div>
      </template>
      <ax-fold v-if="list.length > 1">
        <template v-for="(item, index) in list">
          <div
            :class="['risk-item', 'item' + item.labelLevel]"
            :style="{ color: item.labelColor , backgroundColor: hexToRgba(item.labelColor, 0.1)}"
            v-if="index > 0 && item.labelName"
            :key="index"
          >
            <div class="risk-level">{{ item.labelName }}</div>
            <p class="comment">{{ item.comment }}</p>
          </div>
        </template>
      </ax-fold>
    </div>
  </ax-panel>
</template>

<script>
export default {
  name: "risk-level",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    //hex -> rgba
    hexToRgba(hex, opacity) {
      // hex = '#bfbbb4'
      return (
        "rgba(" +
        parseInt("0x" + hex.slice(1, 3)) +
        "," +
        parseInt("0x" + hex.slice(3, 5)) +
        "," +
        parseInt("0x" + hex.slice(5, 7)) +
        "," +
        opacity +
        ")"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.risk-level-wrapper {
  padding: 0 16px 10px;
}
.risk-item {
  margin-bottom: 10px;
  padding: 10px;
  border-radius: 4px;
  .risk-level {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 5px;
    &.item1 {
      color: #f84e44;
    }
    &.item2 {
      color: #fd7313;
    }
    &.item3 {
      color: #ffa300;
    }
    &.item4 {
      color: #7748a7;
    }
    &.item5 {
      color: #006bff;
    }
  }
  .comment {
    font-size: 12px;
    color: #666666;
    line-height: 17px;
    word-break: break-all;
  }
}
</style>